module.exports = __webpack_public_path__ + "static/img/img-tips.be19ce9b.png";